import { useFilterPanelContext } from "../../filter-panel.context";
import { pruneFilterValue, serializeFilterValue } from "../../filter-panel.model";
import { CAN_SAVE_FILTER } from "../../filter-panel.constants";
import { SAVE_FILTER_LABEL } from "../../messages";
import type {
  FilterPanelSaveButtonProps,
  FilterPanelSaveButtonViewProps,
} from "./types-save-button";

/** ViewModel do FilterPanel.SaveButton: desabilitado sem critérios, quando o rascunho já é um filtro salvo ou enquanto `CAN_SAVE_FILTER` for falso; sem JSX. */
export function useFilterPanelSaveButton({
  saved,
  onClick,
  disabled,
  ...rest
}: FilterPanelSaveButtonProps): FilterPanelSaveButtonViewProps {
  const { draft, hasCriteria, partTestId } = useFilterPanelContext();
  const draftKey = serializeFilterValue(pruneFilterValue(draft));
  const alreadySaved = (saved ?? []).some((item) => serializeFilterValue(item.value) === draftKey);

  return {
    label: SAVE_FILTER_LABEL,
    disabled: !CAN_SAVE_FILTER || Boolean(disabled) || !hasCriteria || alreadySaved,
    onClick,
    testId: partTestId("save"),
    rest,
  };
}
